import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { PAYMENT_ENABLED } from '../../../constants/payment.js';
import { SUPPORT_ZALO_URL } from '../../../constants/supportBotData.js';

export function LessonPaywall({ message }) {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        icon={<LockOutlined style={{ color: '#f59e0b' }} />}
        title={PAYMENT_ENABLED ? 'Bài học thuộc gói trả phí' : 'Bài học thuộc gói hội viên'}
        subTitle={
          PAYMENT_ENABLED
            ? message || 'Vui lòng nâng cấp gói học để tiếp tục xem nội dung này.'
            : 'Nền tảng đang trong giai đoạn thử nghiệm miễn phí. Bài học này sẽ mở khi các gói hội viên được mở đăng ký. Cần hỗ trợ, anh/chị nhắn Zalo cho đội ngũ Thế Thảo Pharma.'
        }
        extra={[
          PAYMENT_ENABLED ? (
            <Button key="upgrade" type="primary" style={{ background: '#005537', borderColor: '#005537' }} onClick={() => navigate('/courses?tab=pricing')}>
              Xem các gói học
            </Button>
          ) : (
            <Button key="zalo" type="primary" href={SUPPORT_ZALO_URL} target="_blank" rel="noopener noreferrer" style={{ background: '#0068ff', borderColor: '#0068ff' }}>
              Nhắn Zalo hỗ trợ
            </Button>
          ),
          <Button key="back" onClick={() => navigate('/courses')}>
            Về danh sách chuyên đề
          </Button>,
        ]}
      />
    </div>
  );
}
